import isValid from 'date-fns/isValid';
import addDays from 'date-fns/addDays';

import type { TrialDetailsQuery } from './__types__/TrialDetailsQuery.ts';

const GRACE_PERIOD = 14; // days after trial ends for both HAMS and CCP

type LocalTrialEndDates = {
	deactivationDate: Date;
	trialEndDate: Date;
};

export const useLocalTrialEndDatesFromQuery = (
	queryData: TrialDetailsQuery | undefined,
): LocalTrialEndDates | null => {
	const trialEndDateString = queryData?.license?.trialEndDate;

	// When the customer starts an instance, the exact timestamp of the trial end is not
	// recorded. We made the decision to always return the UTC date for `trialEndDate`.
	const trialEndDate = trialEndDateString ? new Date(trialEndDateString) : null;

	if (!trialEndDate || !isValid(new Date(trialEndDate))) {
		return null;
	}

	const deactivationDate = addDays(trialEndDate, GRACE_PERIOD);

	return {
		deactivationDate,
		trialEndDate,
	};
};
